import React, { useEffect, useRef, useState } from 'react';
import './dooropen.css';
import Settings from '../components/common/settings';
import { useNavigate } from 'react-router-dom';

const TOTAL_TIME = 10 * 60;

const getInitialTime = () => {
  const saved = localStorage.getItem('room1_time');

  if (!saved) {
    localStorage.setItem('room1_time', Date.now());
    return TOTAL_TIME;
  }

  const elapsed = Math.floor((Date.now() - Number(saved)) / 1000);
  return Math.max(TOTAL_TIME - elapsed, 0);
};

const Dooropen = () => {
  const navigate = useNavigate();
  const bgRef = useRef(null);

  const [zoom, setZoom] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [timeLeft, setTimeLeft] = useState(getInitialTime());

  useEffect(() => {
    const timer = setTimeout(() => {
      setZoom(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const bg = bgRef.current;

    const handleTransitionEnd = (e) => {
      if (e.propertyName === 'transform') {
        navigate('/safepage');
      }
    };

    bg?.addEventListener('transitionend', handleTransitionEnd);

    return () => {
      bg?.removeEventListener('transitionend', handleTransitionEnd);
    };
  }, [navigate]);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => Math.max(prev - 1, 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');
  const isWarning = timeLeft <= 60;
  const fillPercent = (timeLeft / TOTAL_TIME) * 100;

  return (
    <section className="dooropen">
      <div
        ref={bgRef}
        className={`doorbg ${zoom ? 'zoom' : ''}`}
      />
      <div className="layer">
        <div className="room1nav">
          <div />

          <div className="roomtimer">
            <span className="timerlabel">TIME REMAINING</span>

            <div className="timerdiv">
              <span
                className={`timerdigits ${
                  isWarning ? 'timerwarning' : ''
                }`}
              >
                {minutes}:{seconds}
              </span>
            </div>

            <div className="timerbar">
              <div
                className="timerbartill"
                style={{
                  width: `${fillPercent}%`,
                  background: isWarning ? '#ff4444' : '#D4AF37',
                }}
              />
            </div>
          </div>

          <div
            className="settings"
            onClick={() => setOpenSettings(true)}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </div>

      <Settings
        open={openSettings}
        onClose={() => setOpenSettings(false)}
        onNavigate={navigate}
      />
    </section>
  );
};

export default Dooropen;